// src/components/SideMenu/SideMenu.js
import React, { memo, useMemo } from "react";
import { useAuth } from "../../context/AuthContext";
import DynamicMenu from "../DynamicMenu/index";
import "./sidebar.css";

const SideMenu = ({ isOpen }) => {
  const { authData } = useAuth();
  const hotelName = authData?.hotelName || "Hotel";

  const initial = useMemo(() => (hotelName || "").trim().charAt(0).toUpperCase() || "H", [hotelName]);

  // Trial countdown is only present for owners on a trial; hide the footer otherwise.
  const trialDays = Number(authData?.trialTime) || 0;

  return (
    <div className={`hms-side ${isOpen ? "is-open" : "is-closed"}`}>
      <div className="hms-brand" title={hotelName}>
        <div className="hms-brand-mark">{initial}</div>
        {isOpen && (
          <div className="hms-brand-text">
            <div className="hms-brand-name">{hotelName}</div>
            <div className="hms-brand-caption">Hotel Management</div>
          </div>
        )}
      </div>

      <div className="hms-side-scroll">
        <DynamicMenu showLabels={isOpen} />
      </div>

      {isOpen && trialDays > 0 && (
        <div className="hms-side-footer">
          <span className="hms-chip is-warn">
            Trial · {trialDays} {trialDays === 1 ? "day" : "days"} left
          </span>
        </div>
      )}
    </div>
  );
};

export default memo(SideMenu);
